import React, { useEffect, useState, memo } from 'react';
import RadioButton from '../../../components/Dashboard-res/CommonComponent/RadioButton';
import { useFormikContext } from 'formik';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import Styles from './companyDetails.module.css';
import * as _ from 'lodash';
import {
  getUploadUrlForBusinessAddressProof,
  confirmBusinessAddressProofUploaded,
  UploadFileToS3,
  saveBusinessAddressProof,
  getBusinessAddressProof,
  addSelpEmployeedDetails,
  getSelpEmployeedDetails
} from '../../../common/constants/api';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import PopUp from '../../../common/components/PopUp/PopUp';
import { ShowGetImage } from '../../../common/components/ShowGetImage/ShowGetImage';
import GlobalUploadComp from '../../../common/components/GlobalUploadComp/GlobalUploadComp';
import initialImg from '../../../images/icons/upload_new.svg';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
const { gst_field } = Styles;
const getGst = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm
  } = useFormikContext();
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [preValues, setpreValues] = useState(values.preValues());
  const [Edit1, setEdit1] = useState(false);
  const [imgLinkData, setImgLinkData] = useState(null);
  const commonInputEffect = { height: '52px', maxWidth: '100%' };

  useEffect(() => {
    async function handleFlow() {
      if (
        _.get(preValues, 'companyDetails.companyType', false) == 'LLP' ||
        _.get(preValues, 'companyDetails.companyType', false) ==
          'Proprietorship'
      ) {
        await setFieldValue('gst_number', 'no');
        handleSubmit();
      }
    }
    handleFlow();
  }, []);

  useEffect(() => {
    setType('loading');
    setText('Getting Details Please Wait...');
    setShow(true);

    getSelpEmployeedDetails(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId
    )
      .then(res => {
        setShow(false);

        setFieldValue('gst_value', _.get(res, 'gstNumber', ''));
        setFieldValue('companyType', _.get(res, 'companyType', ''));
        setFieldValue('company_name', _.get(res, 'companyName', ''));
        setFieldValue('cin', _.get(res, 'cin', ''));
        setFieldValue('nature_of_business', {
          value: _.get(res, 'natureOfBusiness.id', ''),
          label: _.get(res, 'natureOfBusiness.name', 'Nature Of Business')
        });
        setFieldValue('industry_list', {
          value: _.get(res, 'industry.id', ''),
          label: _.get(res, 'industry.name', 'Choose Industry')
        });
        setFieldValue('sub_industry', {
          value: _.get(res, 'subIndustry.id', ''),
          label: _.get(res, 'subIndustry.name', 'Choose Sub Industry')
        });
        setFieldValue('company_pan', _.get(res, 'companyPan', ''));
      })
      .catch(error => {
        setShow(false);
      });
  }, []);
  const submitValues = () => {
    setType('loading');
    setText('Submitting Please Wait...');
    setShow(true);
    let body = {
      companyType: values?.companyType,
      natureOfBusinessId: values?.nature_of_business?.value,
      industryId: values?.industry_list?.value,
      subIndustryId: values?.sub_industry?.value,
      companyPan: values?.company_pan,
      gstNumber: values?.gst_value,
      cin: values?.cin,
      companyName: values?.company_name
    };
    addSelpEmployeedDetails(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId,
      body
    )
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setShow(false);
        handleSubmit();
      })
      .catch(error => {
        setType('fail');
        setText(_.get(error, 'response.data.message', 'Something went wrong!'));
        setShow(true);
      });
  };

  function gstCertificateSave() {
    saveBusinessAddressProof(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId,
      { gstNumber: values?.gst_value },
      'gst-certificate'
    )
      .then(res => {})
      .catch(error => {
        setShow(false);
      });
  }

  const handleSubmition = () => {
    validateForm().then(res => {
      if (Object.keys(res).length == 0) {
        submitValues();
        if (values?.gst_number == 'yes') {
          gstCertificateSave();
        }
      } else {
        handleSubmit();
      }
    });
  };

  useEffect(() => {
    getBusinessAddressProof(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId,
      'gst-certificate'
    )
      .then(res => {
        if (res?.links?.[0]) {
          setImgLinkData(res?.links?.[0]);
        }
      })
      .catch(err => {
        setShow(false);
      });
  }, []);

  async function fileUpload() {
    setType('loading');
    setText('Uploading the File Please Wait...');
    setShow(true);
    await getUploadUrlForBusinessAddressProof(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId,
      'gst-certificate'
    )
      .then(res => {
        UploadFileToS3(res?.url, values?.file[0][0]).then(() => {
          confirmBusinessAddressProofUploaded(
            getApplicantionInfo().leadId,
            getApplicantionInfo().leadApplicantId,
            res?.requestId || '',
            'gst-certificate'
          ).then(res => {
            setType('success');
            setText('Uploaded the File successfully.');
            setShow(false);
          });
        });
      })
      .catch(err => {
        setShow(false);
      });
  }
  useEffect(() => {
    if (values?.file[0] && values?.file[0][0]) {
      fileUpload();
    }
  }, [values?.file[0]]);

  return (
    <div className="w-full px-8">
      <div className="font-roboto font-medium text-base text-black-850  mt-7 hidden md:block ">
        Company Details
      </div>
      <div className="font-roboto font-normal text-sm text-grey-2000 mt-5 ">
        Do you have GST Number?
      </div>
      <div className="w-full flex  py-3 mt-1">
        <div className="flex flex-row ">
          <RadioButton
            name="gst_number"
            value={values.gst_number == 'yes' ? true : false}
            checked={values.gst_number == 'yes' ? true : false}
            onChange={e => {
              setFieldValue('gst_number', 'yes');
            }}
            onBlur={handleBlur}
          />
          <p className="font-roboto font-normal text-grey-2000 md:px-3 mr-auto px-1">
            Yes
          </p>
        </div>
        <div className="mr-auto flex md:ml-10 flex-row ml-16 ">
          <RadioButton
            name="gst_number"
            value={values.gst_number == 'no' ? true : false}
            checked={values.gst_number == 'no' ? true : false}
            onChange={e => {
              setFieldValue('gst_number', 'no');
            }}
            onBlur={handleBlur}
          />
          <p className="font-roboto font-normal text-grey-2000 md:px-3  mr-auto px-1">
            No
          </p>
        </div>
      </div>
      {values.gst_number == 'yes' ? (
        <div className="w-full mt-4">
          <div className="font-roboto font-normal text-sm text-grey-2000 mt-5 ">
            Enter GST Number
          </div>
          <div className={`${gst_field} w-full md:w-6/12 mt-2 `}>
            <CommonInput
              name="gst_value"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.gst_value}
              stylesContainer={commonInputEffect}
              legendName=""
              error={touched.gst_value && errors.gst_value}
              errorMsg={errors.gst_value}
              touched={touched.gst_value}
            />
          </div>
          <p className="font-roboto font-medium md:text-base text-black-1011 my-4 mt-8">
            Upload GST Certification
          </p>
          <div
            className="bg-white mt-8 flex justify-center md:justify-start rounded-lg border border-navy-200 md:border-none

            py-9  pr-5 pl-8  md:py-0 md:pl-0 md:pr-0 w-64 md:w-full"
          >
            {imgLinkData?.url && !Edit1 ? (
              <div className="md:mr-auto md:ml-3 ">
                <ShowGetImage img={imgLinkData?.url} setEdit={setEdit1} />
              </div>
            ) : (
              <GlobalUploadComp
                data={values}
                imgIndex={0}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                handleBlur={handleBlur}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                setFieldError={setFieldError}
                initialImg={initialImg} // initial image
                subInst="Click here or drop here to upload"
                subtext="CHOOSE IMAGE"
              />
            )}
          </div>
        </div>
      ) : null}
      <button
        type="button"
        className="submitButton font-roboto text-white text-base w-48"
        onClick={handleSubmition}
        disabled={Object.keys(errors).length != 0 ? true : false}
      >
        NEXT
      </button>
      <PopUp type={type} text={text} setShow={setShow} show={show} />
    </div>
  );
};

export default memo(withErrorHandler(getGst));
